// extracted by mini-css-extract-plugin
export default {"card":"BlogCard_card__daWEd","card_content":"BlogCard_card_content__9f7Rg","descriptionContainer":"BlogCard_descriptionContainer__XjOH5"};